import { inject, Injectable } from '@angular/core';
import { AxiosHttpService } from './axios-http.service';
import { ApiResponse } from '../interfaces/api-response.model';
import { API_ENDPOINTS } from '../constants/api.constants';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface MemberInfoResponse {
  success: boolean;
  statusCode: string;
  data?: {
    idNo: string;
    uuid: string;
    name: string;
    birthday: string;
    gender: string;
    email: string;
    cell: string;
  };
  errorMessage?: string;
  timestamp: string;
}

/**
 * 會員中心修改個人資料 service
 */
@Injectable({
  providedIn: 'root',
})
export class ModifyInfoService {
  axiosHttpService: AxiosHttpService = inject(AxiosHttpService);
  http: HttpClient = inject(HttpClient);

  /**
   * 原密碼驗證，使用者需要先輸入舊密碼進行驗證，若驗證失敗超過 5 次需鎖帳號 15 分鐘
   * @param idNo
   * @param password
   */
  verifyCurrentPassword(
    password: string
  ): Observable<ApiResponse<null>> {
    // TODO 改使用post請求
    return this.http.post<ApiResponse<null>>(
      API_ENDPOINTS.VERIFY_CURRENT_PASSWORD,
      { password }
    );
  }
  
  /**
   * 查詢會員資料
   */
  getMemberInfo(): Observable<MemberInfoResponse> {
    return this.http.get<MemberInfoResponse>(API_ENDPOINTS.GET_MEMBER_INFO);
  }
}
